<div class="col-lg-12" id="container-hubspot">
  <!-- Botón de cierre para Modal de Angular Material -->
  <div  type="button" class="close" mat-dialog-close aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </div>

  <h4 class="title" *ngIf="title">Completá tus datos para recibir más información</h4>

  <!-- Estado de Carga -->
  <div *ngIf="loading" class="loading-state">Cargando...</div>

  <!-- Formulario Principal -->
  <form *ngIf="!loading && !isSubmitted" [formGroup]="dynamicForm" (ngSubmit)="onSubmit()" class="hubspot-grid-form">

    <ng-container *ngFor="let field of fields">

      <!-- Contenedor condicional dinámico (Muestra u oculta según dependencias) -->
      <div *ngIf="shouldShowField(field)"
        [ngClass]="{ 'full-width': isFullWidth(field), 'half-width': !isFullWidth(field) }" class="form-field-group">

        <label [for]="field.name">
          {{ field.label && field.label !== '' ? field.label : field.description }}
          <span *ngIf="field.required" class="required-asterisk">*</span>
        </label>

        <!-- Switch Principal por tipo de campo de HubSpot -->
        <ng-container [ngSwitch]="field.fieldType">

          <!-- CASO 1: Teléfono con Prefijo de País -->
          <div *ngSwitchCase="'phonenumber'" class="phone-container">
            <select class="country-prefix hs-input" (change)="onCountryChange($any($event.target).value)">
              <option *ngFor="let c of COUNTRIES_LIST" [value]="c.code" [selected]="c.code === 'AR'">
                {{ c.name }} ({{ c.prefix }})
              </option>
            </select>

            <div class="phone-input-wrapper">
              <span class="prefix-number">{{ selectedPrefix }}</span>
              <input type="text" [formControlName]="field.name" placeholder="Número" class="hs-input">
            </div>
          </div>

          <!-- CASO 2: Selects / Enumeraciones Dropdown -->
          <select *ngSwitchCase="'select'" [formControlName]="field.name" class="hs-input">
            <option value="" disabled selected>Selecciona una opción</option>
            <option *ngFor="let opt of field.options" [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>

          <!-- CASO 3: Textarea para Mensajes Largos (Comentarios, consultas, etc.) -->
          <textarea *ngSwitchCase="'textarea'" [formControlName]="field.name" [placeholder]="field.placeholder || ''"
            class="hs-input textarea-control" rows="4">
          </textarea>

          <div *ngSwitchCase="'radio'" class="options-wrapper-group">
            <div *ngFor="let opt of field.options" class="radio-option">
              <input type="radio" [id]="field.name + '_' + opt.value" [value]="opt.value"
                [formControlName]="field.name">
              <label [for]="field.name + '_' + opt.value">{{ opt.label }}</label>
            </div>
          </div>

          <div *ngSwitchCase="'checkbox'" class="options-wrapper-group">
            <div *ngFor="let opt of field.options" class="checkbox-option">
              <input type="checkbox" [id]="field.name + '_' + opt.value"
                (change)="onCheckboxChange(field.name, opt.value, $any($event.target).checked)">
              <label [for]="field.name + '_' + opt.value">{{ opt.label }}</label>
            </div>
          </div>

          <!-- CASO POR DEFECTO: Inputs convencionales (text, email, number) -->
          <input *ngSwitchDefault [type]="field.fieldType === 'number' ? 'number' : 'text'"
            [formControlName]="field.name" [placeholder]="field.placeholder || ''" class="hs-input">
        </ng-container>

        <!-- Mensajes de Error y Validación de campos -->
        <div
          *ngIf="dynamicForm.get(field.name)?.invalid && (dynamicForm.get(field.name)?.dirty || dynamicForm.get(field.name)?.touched)"
          class="error-message">
          <span *ngIf="dynamicForm.get(field.name)?.errors?.['required']">
            Rellena este campo obligatorio.
          </span>
          <span *ngIf="dynamicForm.get(field.name)?.errors?.['email']">
            Por favor, ingresa un correo válido.
          </span>
        </div>

      </div>
    </ng-container>

    <!-- Botón de Envío -->
    <div class="button-container">
      <button type="submit" class="btn-send" [disabled]="dynamicForm.invalid">Enviar</button>
    </div>
  </form>

  <!-- Mensaje de Éxito Post-Envío -->
  <div *ngIf="isSubmitted" class="success-message">
    <h4>¡Muchas gracias!</h4>
    <p>Tu consulta ha sido enviada con éxito.</p>
  </div>
</div>